import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, FormGroup, Form,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle, Label, NavDropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import { withRouter } from 'react-router'

import ShopFilterCollapseUnder768 from '../components/ShopFilterCollapseUnder768.js';
import ShopFilterSearchTextbox from '../components/ShopFilterSearchTextbox.js';
import ShopContentUnder768 from '../components/ShopContentUnder768.js';
import ShopContentOver767 from '../components/ShopContentOver767.js';

class Shop extends Component {
  static propTypes = {
    products: PropTypes.array.isRequired,
    windowWidth: PropTypes.number.isRequired,
    scrollToSection: PropTypes.func.isRequired,
    addItemToCartState: PropTypes.func.isRequired,
    addItemToCart: PropTypes.func.isRequired,
    cartItemCount: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      searchValue: "",
      sortOrder: ["relevance", "name"],
      usableProducts: [],
      visibleProducts: [],
      searchProducts: [],
      filterProducts: [],
      productTypeInfo_DictionaryArray: [],
      hasMoreToScroll: true,
      filterOpen: false,
      productCategoryOpen: false,
      checked_jars: false,
      checked_votives: false,
      checked_tarts: false,
      dropdownOpen: false,
      dropdownValue: "Relevance",
      showScrollUpButton: false
    };
  }

  componentDidMount() {
    this.handleUrlParams();
    this.initializeUsableProducts();
    this.initializeProductTypeInfo();
    this.handleScrolling();
    window.onscroll = () => { this.handleScrolling() }
    this.props.setShopIsMounted();
  }

  componentWillUnmount() {
    window.onscroll = null;
    this.props.setShopIsMounted();
  }

  handleScrolling = () => { 
    if(window.pageYOffset > 300) {  this.setState({ showScrollUpButton: true }) } 
    else { this.setState({ showScrollUpButton: false }) }
  }
  scrollToTop = () => { this.props.scrollToSection("root", -200) }

  handleUrlParams = () => {
    let initialFilter = this.props.match.params.initialFilter;
    if(initialFilter == "new") { 
      this.setState({ 
        dropdownValue: "Date (newest first)", 
        sortOrder: ["-dateAdded", "relevance"]
      })
    }
  }

  initializeUsableProducts = () => {
    let usableProducts = this.props.products.slice(0).filter(product => product.inSeason && !product.isDiscontinued);
    this.setState({ usableProducts, searchProducts: usableProducts, filterProducts: usableProducts }, () => this.defaultSortUsableProducts("initial"));
  }

  defaultSortUsableProducts = (origin) => {
    if(origin === "initial" || origin === "setSearch" || origin === "setFilter") {
      let sortedUsableProducts = this.state.usableProducts.sort(this.fieldSorter(this.state.sortOrder));
      
      // Put photos with an existing image on top of the rest of the sort.
      if(this.props.match.params.initialFilter !== "new") {
        let existingPhotosSortedUsableProducts = [];
        let stockPhotosSortedUsableProducts = [];
        for(let i=0; i<sortedUsableProducts.length; i++) {
          let product = sortedUsableProducts[i];
          if(product.imgURL.toUpperCase().includes("STOCKPHOTO")) {
            stockPhotosSortedUsableProducts.push(product);
          }
          else {
            existingPhotosSortedUsableProducts.push(product);
          }
        }
        
        sortedUsableProducts = [];
        sortedUsableProducts = [...existingPhotosSortedUsableProducts, ...stockPhotosSortedUsableProducts];
      }

      this.setState({ usableProducts: sortedUsableProducts }, () => this.setVisibleProducts(origin));
    }
  }

  setVisibleProducts = (origin) => {
    let visibleCount = 12;
    let hasMoreToScroll = true;
    let visibleProducts = []

    // If enough products are left to use the declared visibleCount, do so. Otherwise, just put the amount left into visibleProducts.
    if(this.state.usableProducts.length <= visibleCount) {
      visibleCount = this.state.usableProducts.length;
      hasMoreToScroll = false;
    }

    if(origin === "initial" || origin === "setSearch" || origin === "setFilter" || origin === "dropdownSort") {
      visibleProducts = this.state.usableProducts.slice(0, visibleCount);
      this.setState({ visibleProducts, hasMoreToScroll });
    }
  }

  setSearchProducts = () => {
    let searchProducts = this.props.products;

    if(this.state.searchValue.length > 0) {
      // If the search value is in the product's name, keep that product in the array.
      searchProducts = searchProducts.filter(product => product.name.toUpperCase().includes(this.state.searchValue.toUpperCase()));
    }
    
    this.props.scrollToSection("root", -100);
    this.setState( { searchProducts }, () => this.setUsableProducts("setSearch") )
  }

  setFilterProducts = () => {
    let filterProducts = [];

    // If any filter is checked, create the proper filterProducts array. If none are checked, just return filterProducts as all products.
      if(this.state.checked_jars || this.state.checked_votives || this.state.checked_tarts )
      {
        for(let i=0; i<this.props.products.length; i++) {
          let product = this.props.products[i];
          let type = this.props.products[i].type.toUpperCase();
          let subType = this.props.products[i].subType.toUpperCase();
          
          if(type === "CANDLE") {
            if(this.state.checked_jars && subType === "JAR")
            {
              filterProducts.push(product);
            }
            if(this.state.checked_votives && subType === "VOTIVE")
            {
              filterProducts.push(product);
            }
            if(this.state.checked_tarts && subType === "TART")
            {
              filterProducts.push(product);
            }
          }
        }
      }
      else 
      {
        filterProducts = this.props.products;
      }

    // Update the "Filters Display" dictionary. This is not related to the rest of the logic in this function much.
    let productTypeInfo_DictionaryArray = this.state.productTypeInfo_DictionaryArray;
    productTypeInfo_DictionaryArray.map((productTypeInfo, index, dictionary) => {
      // Set 'IsActiveFilter' to the current checked state for that filter.
      productTypeInfo.IsActiveFilter = this.state[productTypeInfo.CheckedState];
    })

    this.setState( { filterProducts, productTypeInfo_DictionaryArray }, () => this.setUsableProducts("setFilter") )
  }

  // Only called after a user performs a search or sets a filter. Initial page load does not call this function.
  setUsableProducts = (origin) => {
    let intersectionOfProducts = new Set(this.state.searchProducts.filter(x => new Set(this.state.filterProducts).has(x)));
    let usableProducts = [...intersectionOfProducts];
    
    if(origin === "setSearch" || origin === "setFilter") {
      this.setState({ usableProducts }, () => this.defaultSortUsableProducts(origin));
    }
  }

  setSearchValue = (event) => { 
    this.setState({ searchValue: event.target.value }, () => this.setSearchProducts() ); 
  }

  dropdownSort = (choice) => {
    // Can sort by Relevance, Price low to high, price high to low, date added (newest first), 
    let sortOrder = [];
    switch(choice) {
      case "Relevance":
        sortOrder.push("relevance", "name");
        break;
      case "Price (low to high)":
        sortOrder.push("price", "relevance");
        break;
      case "Price (high to low)":
        sortOrder.push("-price", "relevance");
        break;
      case "Date (newest first)":
        sortOrder.push("-dateAdded", "relevance");
        break;
      case "Alphabetical (A-Z)":
        sortOrder.push("name", "price");
        break;
    }
    let sortedUsableProducts = this.state.usableProducts.sort(this.fieldSorter(sortOrder));
    this.setState({ usableProducts: sortedUsableProducts, sortOrder }, () => this.setVisibleProducts("dropdownSort"));
  }

  selectDropdownItem = (event) => { 
    this.setState({ 
      dropdownOpen: !this.state.dropdownOpen, 
      dropdownValue: event.target.innerText 
    }); 
    
    this.dropdownSort(event.target.innerText);
  }

  toggleDropdownOpen = () => { this.setState({ dropdownOpen: !this.state.dropdownOpen }); }

  loadMoreScroll = () => {
    let visibleProducts = this.state.visibleProducts.slice(0);
    let visibleCount = this.state.visibleProducts.length;
    let startIterator = visibleCount;
    let amountToLoad = 12;
    let hasMoreToScroll = true;

    if(visibleCount + amountToLoad >= this.state.usableProducts.length) {
      amountToLoad = this.state.usableProducts.length - visibleCount;
      hasMoreToScroll = false;
    }

    visibleCount += amountToLoad;

    for(let i=startIterator; i<visibleCount; i++) {
      visibleProducts.push(this.state.usableProducts[i]);
    }

    this.setState({ visibleProducts, hasMoreToScroll });
  }

  toggleFilter = () => { this.setState({filterOpen: !this.state.filterOpen}); }
  toggleProductCategory = () => { this.setState({productCategoryOpen: !this.state.productCategoryOpen}); }

  jarsCheck = () => { this.setState({checked_jars: !this.state.checked_jars}, () => this.setFilterProducts() ); }
  votivesCheck = () => { this.setState({checked_votives: !this.state.checked_votives}, () => this.setFilterProducts() ); }
  tartsCheck = () => { this.setState({checked_tarts: !this.state.checked_tarts}, () => this.setFilterProducts() ); }

  initializeProductTypeInfo = () => {
    let productTypeInfo_DictionaryArray = 
    [
      {
        "FilterDisplay": "Jar Candles",
        "CheckedState": "checked_jars",
        "CheckedFunction": "jarsCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Votives",
        "CheckedState": "checked_votives",
        "CheckedFunction": "votivesCheck",
        "IsActiveFilter": false
      },
      {
        "FilterDisplay": "Tarts",
        "CheckedState": "checked_tarts",
        "CheckedFunction": "tartsCheck",
        "IsActiveFilter": false
      }
  ]
    this.setState({ productTypeInfo_DictionaryArray });
  }

  fieldSorter = (fields) => {
    return (a, b) => fields.map(o => {
        let dir = 1;
        if (o[0] === '-') { dir = -1; o=o.substring(1); }
        return a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
    }).reduce((p,n) => p ? p : n, 0);
  }

  render () {
  	return (
		<div>
      <Helmet>
        <title>Shop Lasting Scents - Primitives Candles</title>
      </Helmet>

      {
        this.props.windowWidth < 768 
        ? 
        <ShopFilterCollapseUnder768 windowWidth={this.props.windowWidth} toggleFilter={this.toggleFilter} 
          toggleProductCategory={this.toggleProductCategory} jarsCheck={this.jarsCheck}
          votivesCheck={this.votivesCheck} tartsCheck={this.tartsCheck}
          {...this.state} 
          /> 
        : ""
      }

      {
        this.props.windowWidth < 768
        ? 
          <ShopContentUnder768 windowWidth={this.props.windowWidth} toggleFilter={this.toggleFilter} 
            toggleProductCategory={this.toggleProductCategory} jarsCheck={this.jarsCheck}
            votivesCheck={this.votivesCheck} tartsCheck={this.tartsCheck}
            {...this.state} {...this.props}
            addItemToCart={this.props.addItemToCart} addItemToCartState={this.props.addItemToCartState} cartItemCount={this.props.cartItemCount}
            dropdownSort={this.dropdownSort} selectDropdownItem={this.selectDropdownItem} 
            toggleDropdownOpen={this.toggleDropdownOpen} scrollToTop={this.scrollToTop}  loadMoreScroll={this.loadMoreScroll}
            setSearchValue={this.setSearchValue} addItemToCart={this.props.addItemToCart}
            /> 
        : ""
      }

      {
        this.props.windowWidth > 767
        ? 
          <ShopContentOver767 windowWidth={this.props.windowWidth} toggleFilter={this.toggleFilter} 
            toggleProductCategory={this.toggleProductCategory} jarsCheck={this.jarsCheck}
            votivesCheck={this.votivesCheck} tartsCheck={this.tartsCheck}
            {...this.state} {...this.props}
            addItemToCart={this.props.addItemToCart} addItemToCartState={this.props.addItemToCartState} cartItemCount={this.props.cartItemCount}
            dropdownSort={this.dropdownSort} selectDropdownItem={this.selectDropdownItem} 
            toggleDropdownOpen={this.toggleDropdownOpen} scrollToTop={this.scrollToTop}  loadMoreScroll={this.loadMoreScroll}
            setSearchValue={this.setSearchValue}
            /> 
        : ""
      }

		</div>
  	);
  }
}

export default withRouter(Shop);




// WEBPACK FOOTER //
// ./src/pages/Shop.js